<script lang="ts">
	import type { Locale } from '$lib/i18n/types';
	import type { AdId } from '$lib/services/advertising/types';
	import { page } from '$app/state';
	import AdvertisingTemplate from '$lib/components/advertising/AdvertisingTemplate.svelte';
	import ItaliaAd from '$lib/components/advertising/ItaliaAd.svelte';
	import OrangeAd from '$lib/components/advertising/OrangeAd.svelte';
	import ReworldAd from '$lib/components/advertising/ReworldAd.svelte';
	import { type AdFormats, isOrangeLoadedStore } from '$lib/services/advertising';

	interface Props {
		adFormat: AdFormats;
		adId: AdId;
		showAdByDefault?: boolean;
		onAdAvailabilityChange?: (isAvailable: boolean) => void;
	}

	const { adFormat, adId, showAdByDefault = false, onAdAvailabilityChange }: Props = $props();

	const adComponentProps: {
		adId: AdId;
		adFormat: AdFormats;
		showAdByDefault: boolean;
		adIdForTests: AdId;
		onAdAvailabilityChange?: (isAvailable: boolean) => void;
	} = {
		adId,
		adFormat,
		showAdByDefault,
		adIdForTests: adId,
		onAdAvailabilityChange,
	};

	function getAdComponent(locale: Locale, isOrangeLoaded: boolean) {
		if (locale === 'fr-FR') {
			return isOrangeLoaded ? OrangeAd : AdvertisingTemplate;
		}

		if (locale === 'it-IT') {
			return ItaliaAd;
		}

		return ReworldAd;
	}

	const AdComponent = $derived(getAdComponent(page.data.locale, $isOrangeLoadedStore));
</script>

<AdComponent {...adComponentProps} />
